import React from "react";

const NavButton = ({ onClick, ariaLabel = "" }) => {
  return (
    <div>
      <button
        aria-label={ariaLabel}
        className="nav_button buttonBlueBorder"
        onClick={onClick}
      >
        <svg
          width="6.17"
          height="11"
          viewBox="0 0 10 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.88 16L0 14.12L6.10667 8L0 1.88L1.88 0L9.88 8L1.88 16Z"
            fill=""
          />
        </svg>
      </button>
    </div>
  );
};

export default NavButton;
